module.exports = __webpack_public_path__ + "assets/img/bg-learn.10d0e43b.png";